<div class="container">
    <div class="row justify-content-center">
        <div class="box col-12 col-sm-8 col-lg-6 col-xl-5">
            <div class="box__cont">
                <div [ngClass]="isNotValidInputs ? '' : 'box__title--otp'" class="box__title">
                    <h1>Setup Challenge</h1>
                    <h2>We have sent a temporary setup challenge to your registered email address. Enter it below to continue MFA setup.</h2>
                    <h3 class="box__error-notif" *ngIf="isNotValidInputs">The input fields are incomplete.</h3>
                </div>
                <div class="box__form">
                    <div [class.error]="isError" class="col-12 box__field">
                        <atram-textbox [parentFormGroup]="searchFormGroup"
                                        type="text"
                                        controlName="temporaryPassword"
                                        label="Temporary Password"
                                        placeholder="Enter temporary password"
                                        [number-only]="false"
                                        [isError]="isError"
                                        [isRequired]="true">
                        </atram-textbox>
                    </div>
                    <div *ngIf="isInvalidCode" class="col-12 box__field box__field--otp text-center">
                            <h3 class="box__error-notif">{{ invalidText || 'Invalid setup challenge. Please try again or request a new one.' }}</h3>
                    </div>
                    <div *ngIf="isLockedOut" class="col-12 box__field box__field--otp text-center">
                        <p>Account locked. Try again in</p>
                        <span>{{ lockoutCountDownTracker }}</span>
                    </div>
                    <div class="row justify-content-center">
                        <div class="d-sm-none col-12">
                            <div class="buttons buttons--dual">
                                <div class="row">
                                    <div class="buttons__first col-12 col-sm-6">
                                        <atram-button label="Confirm"
                                            componentClass="btn-submit"
                                            [disabled]="isLockedOut"
                                            (on-click)="proceed()">
                                        </atram-button>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <atram-button buttonType="default"
                                            label="Back to Sign In"
                                            componentClass="btn-submit"
                                            (on-click)="goToSignIn()">
                                        </atram-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-none d-sm-block col-12">
                            <div class="buttons buttons--dual">
                                <div class="row">
                                    <div class="buttons__first col-12 col-sm-6">
                                        <atram-button buttonType="default"
                                            label="Back to Sign In"
                                            componentClass="btn-submit"
                                            (on-click)="goToSignIn()">
                                        </atram-button>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <atram-button label="Confirm"
                                            componentClass="btn-submit"
                                            [disabled]="isLockedOut"
                                            (on-click)="proceed()">
                                        </atram-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<atram-modal #atramModal></atram-modal>
